import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../components/Header";
import { MainButton } from "../../components/MainButton";
import { Menu } from "../../components/Menu";
import { useOrder } from "../../hooks/useOrder";
import InputMask from "react-input-mask";
import Swal from "sweetalert2";
import { cnpj, cpf } from "cpf-cnpj-validator";

import { useAppConfig } from "../../hooks/useAppConfig";
import { Loading } from "../../components/Loading";
import { ConfigType } from "../../contexts/AppConfigContext";
import "./index.css";
import api from "../../services/api";
import {
    cepNoMask,
    cpfCnpjNoMask,
    dateBRToDateISO,
    datetimeToDateBR,
    rtcToText,
    telephoneNoMask,
} from "../../functions/mask";
import { usePluginspace } from "../../hooks/usePluginspace";
import { CustomerType } from "../../contexts/OrderContext";
import { useSeller } from "../../hooks/useSeller";
import { floatToCents } from "../../functions/price_functions";

type configField = {
    visible: boolean
    mandatory: boolean
    name: string,
    fieldName: string,

}


export function SellerCustomer() {
    const navigate = useNavigate();
    const { pluginspace_id } = useParams();
    const {
        getCustomer,
        getType,
        getOrderAddress,
        synchronizeContextToStorage,
        getCustomerAdress
    } = useOrder();
    const { getToken, registerAccess, getThisPluginspace, getLocations } = usePluginspace();
    const orderContext = useOrder();
    const { getOrder, clearOrder, getOrderWithDiscount } = useOrder();
    const { getTokenSeller, setCustomerToSeller } = useSeller();
    const [useWpp, setUseWpp] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [cpfOrCnpj, setCpfOrCnpj] = useState("");
    const [birthdate, setBirthdate] = useState("");
    const [gender, setGender] = useState("masculino");
    const [telephone, setTelephone] = useState("");
    const [cep, setCep] = useState("");
    const [address, setAddress] = useState("");
    const [district, setDistrict] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [number, setNumber] = useState("");
    const [complement, setComplement] = useState("");
    const [ibge, setIbge] = useState('');
    const [typePluginSpace, setTypePluginSpace] = useState('');



    const [alarmName, setAlarmName] = useState(false);
    const [alarmEmail, setAlarmEmail] = useState(false);
    const [alarmCpf, setAlarmCpf] = useState(false);
    const [alarmBirthdate, setAlarmBirthdate] = useState(false);
    const [alarmTelephone, setAlarmTelephone] = useState(false);
    const [alarmCep, setAlarmCep] = useState(false);
    const [alarmAddress, setAlarmAddress] = useState(false);
    const [alarmDistrict, setAlarmDistrict] = useState(false);
    const [alarmCity, setAlarmCity] = useState(false);
    const [alarmState, setAlarmState] = useState(false);
    const [alarmNumber, setAlarmNumber] = useState(false);
    const [alarmComplement, setAlarmComplement] = useState(false);


    const [maskCpfjCnpj, setMaskCpfjCnpj] = useState("999.999.999-99");
    const [maskTelephone, setMaskTelephone] = useState("(99) 9999-9999");

    const [term, setTerm] = useState("");

    const { getAppConfig } = useAppConfig();
    const [config, setConfig] = useState<ConfigType | void>();
    const [loading, setLoading] = useState(true);


    const [type, setType] = useState("");

    const [hideMenu, setHideMenu] = useState(false);

    const [selectedDoc, setSelectedDoc] = useState('cpf')
    const [inscEstadual, setInscEstadual] = useState('')

    //Tem FieldConfig? (Se não tiver continua igual, se tiver montar de acordo com as configurações)
    const [haveFieldConfig, setHaveFieldConfig] = useState(false)
    const [fieldsConfig, setFieldsConfig] = useState<configField[]>([])

    const [loadingHeader, setLoadingHeader] = useState(true);



    useEffect(() => {
        registerAccess('customer')
        getConfig();
    }, []);

    async function loadOrder() {
        setLoading(true);
        await synchronizeContextToStorage();
        await getToken()
        const customer = await getCustomer();

        if (customer.wppNotification) setUseWpp(customer.wppNotification);
        if (customer.name) setName(customer.name);
        if (customer.email) setEmail(customer.email);
        if (customer.cpf) setCpfOrCnpj(customer.cpf);
        if (customer.birthdate) setBirthdate(customer.birthdate);
        if (customer.gender) setGender(customer.gender);
        if (customer.telephone) setTelephone(customer.telephone);
        if (customer.cep) setCep(customer.cep);
        if (customer.address) setAddress(customer.address);
        if (customer.district) setDistrict(customer.district);
        if (customer.city) setCity(customer.city);
        if (customer.state) setState(customer.state);
        if (customer.number) setNumber(customer.number);
        if (customer.complement) setComplement(customer.complement);
        if (customer.ibge) setIbge(customer.ibge);
        if (customer.inscEstadual) setInscEstadual(customer.inscEstadual)

        const newType = await getType();
        setType(newType)
        const typePlugin = await getThisPluginspace()

        setTypePluginSpace(typePlugin!.type)

        await loadCustomer();

        setLoading(false);
    }

    async function getOrderAddressNew() {
        const typeStorage = await getType();
        const orderAddressStorage = await getOrderAddress();
        if (typeStorage === "delivery") {
            if (orderAddressStorage.city !== undefined)
                setCity(orderAddressStorage.city);
            if (orderAddressStorage.address !== undefined)
                setAddress(orderAddressStorage.address);
            if (orderAddressStorage.district !== undefined)
                setDistrict(orderAddressStorage.district);
            if (orderAddressStorage.cep !== undefined)
                setCep(orderAddressStorage.cep);
            if (orderAddressStorage.number !== undefined)
                setNumber(orderAddressStorage.number);
            if (orderAddressStorage.state !== undefined)
                setState(orderAddressStorage.state);
            if (orderAddressStorage.telephone !== undefined) {
                if (orderAddressStorage.telephone.length >= 11) {
                    setMaskTelephone("(99) 99999-9999");
                } else {
                    setMaskTelephone("(99) 9999-9999");
                }
                setTelephone(orderAddressStorage.telephone);
            }
        } else {
            const endereco = await getCustomerAdress()
            await findCep(endereco.cep)
            setCep(endereco.cep)
        }
    }

    async function getFieldConfig() {
        const fieldConfig = await api.get(
            `/api/fieldconfig`,
            {
                headers: {
                    Authorization: `Bearer ${await getToken()}`,
                },
            }
        )
            .then(async (response) => {
                return response.data.data[0]

            }).catch((err) => {
                console.log(err.data)
                return err
            });


        setHaveFieldConfig(fieldConfig ? true : false)

        if (fieldConfig) {
            const data: configField[] = []
            const regexPattern = new RegExp("true");

            Object.entries(fieldConfig.content).map((fieldConfig: any) => {
                data.push({
                    visible: regexPattern.test(fieldConfig[1].visible),
                    name: fieldConfig[0],
                    fieldName: fieldConfig[1].name,
                    mandatory: regexPattern.test(fieldConfig[1].mandatory),
                })
            })

            setFieldsConfig(data)
        }
    }

    async function loadCustomer() {

        const customerDocumento = await orderContext.getCustomerDocument()
        if (customerDocumento) {
            setCpfOrCnpj(customerDocumento!)
            await findCustomer2(customerDocumento)
        }
    }

    async function getConfig() {
        setLoadingHeader(true);
        setConfig(await getAppConfig());
        setLoadingHeader(false);
        await getOrderAddressNew();
        await getFieldConfig();
        await loadOrder();
        await getTerms();

    }

    async function getTermsTotvs() {
        return await api
            .get(
                `/api/letter-consent`,
                {
                    headers: {
                        Authorization: `Bearer ${await getToken()}`,
                    },
                }
            )
            .then(async (response) => {
                const totvsRes = response.data;
                if (totvsRes && totvsRes.data && totvsRes.data.body) {
                    setTerm(rtcToText(totvsRes.data.body));
                    return true
                } else {
                    return false
                }
            })
            .catch((err) => {
                return false
            });
    }

    async function getTerms() {
        const hasTotvsTerms = await getTermsTotvs();
        if (!hasTotvsTerms) {
            await api
                .post(
                    `/api/consent/filter`,
                    {
                        active: true,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${await getToken()}`,
                        },
                    }
                )
                .then(async (response) => {
                    setTerm(response.data.data[0].content);
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    setLoading(false);
                });
        }
    }

    function verify(verify: boolean, valor: string) {
        /* 
            Regra : 
            Se é obrigatoria verifica se o valor é diferente de vazio || ""
            caso n for obrigatorio retorne true
        */

        if (verify) {
            //verifica se o campo foi escrito ou não
            return valor !== "" ? true : false;
        }
        return true
    }

    // funçao utilizada para validacao de campos
    const validateFields = (fields: any, values: any) => {
        for (const field of fields) {
            if (field.mandatory && !values[field.name]) {
                Swal.fire({
                    icon: "warning",
                    title: "Atenção!",
                    text: `${field.name} inválido`,
                });
                return false;
            }
        }
        return true;
    };

    const createCustomerToSend = (type: string, orderAddressStorage: any, data: any) => {
        const baseCustomer = {
            name: data.name,
            email: data.email,
            phones: [
                {
                    typePhone: "cell",
                    numberPhone: telephoneNoMask(data.telephone),
                },
            ],
            doc: cpfCnpjNoMask(data.cpfOrCnpj),
            cpf: cpfCnpjNoMask(data.cpfOrCnpj),
            optinWhatsapp: data.useWpp ? true : false,
            birthDate: selectedDoc !== 'cnpj' ? dateBRToDateISO(data.birthdate) : null,
            gender: data.gender,
            lgpdDataAceiteCarta: new Date(),
            password: "",
            inscEstadual: data.inscEstadual,
            addresses: [
                {
                    zipCode: cepNoMask(data.cep),
                    street: data.address,
                    number: data.number,
                    district: data.district,
                    city: data.city,
                    state: data.state,
                    extra: data.complement,
                    reference: "",
                    typeAddress: "main",
                    ibge: data.ibge,
                },
            ],
            pluginconfigId: data.config?.content.pdv.pluginconfigId || 0,
        };

        if (type === "delivery") {
            baseCustomer.phones.push({
                typePhone: "cell",
                numberPhone: orderAddressStorage.telephone
                    ? telephoneNoMask(orderAddressStorage.telephone)
                    : orderAddressStorage.telephone,
            });
            baseCustomer.addresses.push({
                zipCode: orderAddressStorage.cep
                    ? cepNoMask(orderAddressStorage.cep)
                    : orderAddressStorage.cep,
                street: orderAddressStorage.address,
                number: orderAddressStorage.number,
                district: orderAddressStorage.district,
                city: orderAddressStorage.city,
                state: orderAddressStorage.state,
                extra: orderAddressStorage.complement,
                reference: "",
                typeAddress: "delivery",
                ibge: orderAddressStorage.ibge,
            });
        }

        return baseCustomer;
    };

    async function createCustomerApi(customerToSend: any) {
        try {
            const response = await api.post(`/api/customer`, customerToSend, {
                headers: {
                    Authorization: `Bearer ${await getToken()}`,
                },
            });

            if (response.data.success) {
                const customer = {
                    id: response.data.dados.id || response.data.dados.dados.id,
                    name,
                    email,
                    cpf: cpfOrCnpj,
                    birthdate,
                    wppNotification: useWpp,
                    acceptTermDate: response.data.dados.lgpdDataAceiteCarta || response.data.dados.dados.lgpdDataAceiteCarta,
                    gender,
                    telephone,
                    cep,
                    address,
                    district,
                    city,
                    state,
                    number,
                    complement,
                    ibge,
                    inscEstadual,
                    customerWinthor: response.data.dados.customerId,
                };

                return {
                    success: true,
                    data: customer
                }
            } else {
                setLoading(false)
                Swal.fire({
                    icon: "warning",
                    title: "Atenção!",
                    text: "Falha ao cadastrar cliente",
                });

                return {
                    success: false,
                    data: {}
                }
            }
        } catch (err) {
            Swal.fire({
                icon: "warning",
                title: "Atenção!",
                text: "Falha ao cadastrar cliente",
            });
            return {
                success: false,
                data: {}
            }

        }
    }
    async function continueOrder() {
        try {



            if (haveFieldConfig) {

                const emailField = fieldsConfig.find((field: configField) => field.name === 'email')
                const birthField = fieldsConfig.find((field: configField) => field.name === 'dataNascimento')
                const genderField = fieldsConfig.find((field: configField) => field.name === 'genero')
                const phoneField = fieldsConfig.find((field: configField) => field.name === 'telefone')

                if (
                    cpfOrCnpj
                    && name
                    && verify(emailField!.mandatory, email)
                    && verify(genderField!.mandatory && selectedDoc !== 'cnpj', gender)
                    && verify(birthField!.mandatory && selectedDoc !== 'cnpj', birthdate)
                    && verify(phoneField!.mandatory, telephone)
                    && cep
                    && address
                    && district
                    && complement
                    && city
                    && state
                    && number

                ) {
                    if (phoneField!.mandatory) {
                        if (telephone.includes("_")) {
                            Swal.fire({
                                icon: "warning",
                                title: "Atenção!",
                                text: "Telefone inválido",
                            });
                            setTelephone("");
                            return;
                        }
                    }

                    if (cep.includes("_")) {
                        Swal.fire({
                            icon: "warning",
                            title: "Atenção!",
                            text: "CEP inválido",
                        });
                        setCep("");
                        return;
                    }

                    if ((name.split(" ").length < 2 || !name.split(" ")[1] || name.split(" ")[1] === '')) {
                        Swal.fire({
                            icon: "warning",
                            title: "Nome inválido!",
                            text: "Informe seu sobrenome",
                        });
                        return
                    }


                    if (cpfOrCnpj.includes("_")) {
                        Swal.fire({
                            icon: "warning",
                            title: "Atenção!",
                            text: "CPF inválido",
                        });
                        setCpfOrCnpj("");
                        return;
                    }

                    if (birthdate.includes("_") && selectedDoc !== 'cnpj') {
                        Swal.fire({
                            icon: "warning",
                            title: "Atenção!",
                            text: "Data de Nascimento inválido",
                        });
                        setBirthdate("");
                        return;
                    }

                    if (emailField!.mandatory) {
                        if (!email.includes("@")) {
                            Swal.fire({
                                icon: "warning",
                                title: "Atenção!",
                                text: "E-mail inválido",
                            });
                            setEmail("");
                            return;
                        }

                    }

                    if (cpfOrCnpj.length <= 14 && !cpf.isValid(cpf.strip(cpfOrCnpj))) {
                        Swal.fire({
                            icon: "warning",
                            title: "Atenção!",
                            text: "CPF inválido",
                        });
                        return;
                    } else if (cpfOrCnpj.length > 14 && !cnpj.isValid(cpfOrCnpj)) {
                        Swal.fire({
                            icon: "warning",
                            title: "Atenção!",
                            text: "CNPJ inválido",
                        });
                        return
                    }
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Erro",
                        text: "Verifique se preencheu todos os campos",
                    });

                    return
                }
            }
            // Não Possui Configurações do Campo e Não é do Tipo FOOD e Retirada
            else {

                if (
                    name &&
                    email &&
                    cpf &&
                    birthdate &&
                    telephone &&
                    cep &&
                    address &&
                    district &&
                    complement &&
                    city &&
                    state &&
                    number &&
                    gender
                ) {
                    if (telephone.includes("_")) {
                        Swal.fire({
                            icon: "warning",
                            title: "Atenção!",
                            text: "Telefone inválido",
                        });
                        setTelephone("");
                        return;
                    }

                    if (cep.includes("_")) {
                        Swal.fire({
                            icon: "warning",
                            title: "Atenção!",
                            text: "CEP inválido",
                        });
                        setCep("");
                        return;
                    }

                    if (birthdate.includes("_") && selectedDoc !== 'cnpj') {
                        Swal.fire({
                            icon: "warning",
                            title: "Atenção!",
                            text: "Data de Nascimento inválido",
                        });
                        setBirthdate("");
                        return;
                    }

                    // Verifica se possui sobrenome
                    if (name.split(" ").length < 2 || !name.split(" ")[1] || name.split(" ")[1] === '') {
                        Swal.fire({
                            icon: "warning",
                            title: "Nome inválido!",
                            text: "Informe seu sobrenome",
                        });
                        return
                    }

                    if (cpfOrCnpj.includes("_")) {
                        Swal.fire({
                            icon: "warning",
                            title: "Atenção!",
                            text: "CPF inválido",
                        });
                        setCpfOrCnpj("");
                        return;
                    }

                    if (!email.includes("@")) {
                        Swal.fire({
                            icon: "warning",
                            title: "Atenção!",
                            text: "E-mail inválido",
                        });
                        setEmail("");
                        return;
                    }

                    const cepOk = await findCep(cep);
                    if (!cepOk) return;

                    if (cpfOrCnpj.length <= 14 && !cpf.isValid(cpf.strip(cpfOrCnpj))) {
                        Swal.fire({
                            icon: "warning",
                            title: "Atenção!",
                            text: "CPF inválido",
                        });
                        return
                    } else if (cpfOrCnpj.length > 14 && !cnpj.isValid(cpfOrCnpj)) {
                        Swal.fire({
                            icon: "warning",
                            title: "Atenção!",
                            text: "CNPJ inválido",
                        });
                        return
                    }


                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Erro",
                        text: "Verifique se preencheu todos os campos",
                    });

                    return
                }
            }
            setLoading(true)
            const orderAddressStorage = await getOrderAddress();
            const customerToSend = createCustomerToSend(type, orderAddressStorage, { name, email, telephone, cpfOrCnpj, useWpp, birthdate, gender, inscEstadual, cep, address, number, district, city, state, complement, ibge, config });

            const customer = await createCustomerApi(customerToSend)

            if (!customer || !customer.success) {

                return null
            }

            const order = await getOrderWithDiscount();
            /*
                Verificar o tipo da compra Delivery | Retirada
                Pegar os endereços
            */

            const orderType = await getType()
            const OrderAddress = await getOrderAddress()




            const tk = getTokenSeller();
            const link = `${window.location.origin}/${window.location.pathname.split("/")[1]
                }/new-choose-payment`;


            //salvar produtos, endereço, tipo de entrega, total da compra e frete
            const jsonCart = {
                products: order.products.map((product: any) => {
                    const variation = Object.entries(product.variation).map(
                        (variationGrid) => {
                            return {
                                grid: variationGrid[0],
                                valor: variationGrid[1],
                            };
                        }
                    );
                    return {
                        id: product.id,
                        img: product.image,
                        sku: product.sku,
                        variation: variation,
                        name: product.name,
                        price: product.unitPrice,
                        unitPrice: product.unitPrice,
                        discount:
                            product.promotionalPrice !== 0 &&
                                product.promotionalPrice !== product.unitPrice
                                ? product.promotionalPrice - product.unitPrice
                                : 0,
                        discountGeral:
                            product.promotionalPrice !== 0 &&
                                product.promotionalPrice !== product.unitPrice
                                ? product.promotionalPrice - product.unitPrice
                                : 0,
                        promotional_price: product.promotionalPrice,
                        quantity: product.quantity,
                        code: product.code,
                        sku_info: [
                            {
                                vendas: null,
                                inventory: product.stock,
                                minimum_stock: null,
                                measures: product.measures
                            },
                        ],
                    };
                }),
                address: OrderAddress,
                type: orderType,
                freight: await orderContext.getFreight(),
                totalDiscount: floatToCents(await orderContext.getDiscountGeneral())

            }
            // criar o carrinho com as informações do cliente
            //cpf. telefone e nome
            const locations = await getLocations()

            const locationId = locations[0]?.id || 0

            const objCustomerCart = {
                customerName: name,
                cpfCustomer: cpfCnpjNoMask(cpfOrCnpj),
                phoneCustomer: telephoneNoMask(telephone),
                cpfSeller: tk?.identifier,
                jsonCart: jsonCart,
                locationId: locationId,
                urlcart: link + "?cart=",
            };
            //Abrir rota do qrcode.
            await api
                .post(`/api/customerCart`, objCustomerCart, {
                    headers: {
                        Authorization: `Bearer ${await getToken()}`,
                    },
                })
                .then(async (response) => {
                    setLoading(false)
                    if (response.status === 201) {
                        setCustomerToSeller({
                            id: response.data.dados.id,
                            name: name,
                            phone: telephoneNoMask(telephone),
                            cpf: cpfCnpjNoMask(cpfOrCnpj),
                            url: link + "?cart=" + response.data.dados.guid,
                            guid: response.data.dados.guid,
                        });
                        clearOrder();
                        navigate(`/${pluginspace_id}/seller-qrcode`);
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Erro ao criar carrinho",
                        });
                        return
                    }
                })
                .catch((err) => {
                    setLoading(false)
                    console.log(err);
                    Swal.fire({
                        icon: "error",
                        title: "Erro ao criar carrinho",
                    });
                    return
                });
        } catch (error) {
            setLoading(false)
            Swal.fire({
                icon: "warning",
                title: "Atenção!",
                text: "Verifique se preencheu todos os campos ou tente novamente mais tarde.",
            });
            return
        }

    }


    function changeTelephone(newPhone: string) {
        const phoneValidated = newPhone.replaceAll("_", "")
        if (phoneValidated.length >= 14 && phoneValidated[13] !== "_") {
            setMaskTelephone("(99) 99999-9999");
        } else {
            setMaskTelephone("(99) 9999-9999");
        }
    }

    async function findCep(cep: string) {
        return await api
            .get(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`)
            .then((response) => {
                if (response.data.erro) {
                    setCity("");
                    setAddress("");
                    setDistrict("");
                    setState("");
                    Swal.fire({
                        icon: "warning",
                        title: "CEP inválido!",
                        text: "Verifique se o CEP foi digitado corretamente.",
                    });
                    return false;
                } else {
                    if (response.data.ibge !== '')
                        setIbge(response.data.ibge);
                    if (response.data.localidade !== "")
                        setCity(response.data.localidade);
                    if (response.data.logradouro !== "")
                        setAddress(response.data.logradouro);
                    if (response.data.bairro !== "")
                        setDistrict(response.data.bairro);
                    if (response.data.uf !== "") setState(response.data.uf);
                    return true;
                }
            })
            .catch(() => {
                setCity("");
                setAddress("");
                setDistrict("");
                setState("");
                Swal.fire({
                    icon: "warning",
                    title: "CEP inválido!",
                    text: "Verifique se o CEP foi digitado corretamente.",
                });
                return false;
            });
    }

    async function findCustomer() {
        if (cpfOrCnpj === undefined || cpfOrCnpj[0] === "_" || (selectedDoc === 'cpf' && !cpf.isValid(cpfOrCnpj)) || (selectedDoc === 'cnpj' && !cnpj.isValid(cpfOrCnpj))) {
            setAlarmCpf(true);
        } else {
            setAlarmCpf(false);
        }
        setLoading(true);
        const cpfWithouthMask = cpfCnpjNoMask(cpfOrCnpj);
        await api
            .post(
                `/api/customer/filter`,
                {
                    cpf: cpfWithouthMask,
                },
                {
                    headers: {
                        Authorization: `Bearer ${await getToken()}`,
                    },
                }
            )
            .then(async (response) => {
                setLoading(false);
                if (response.data.data.length > 0) {
                    const data = response.data.data[0];

                    if (data.name) setAlarmName(false);
                    else setAlarmName(true)
                    setName(data.name);

                    if (data.email) setAlarmEmail(false);
                    else setAlarmEmail(true);
                    setEmail(data.email);

                    if (data.birthDate) setAlarmBirthdate(false);
                    else setAlarmBirthdate(true);
                    setBirthdate(datetimeToDateBR(data.birthDate));

                    if (data.gender) {
                        setGender(data.gender.toLowerCase());
                    } else {
                        setGender("masculino");
                    }

                    if (data.inscEstadual) {
                        setInscEstadual(data.inscEstadual);
                    }

                    if (
                        data.customerPhones[data.customerPhones.length - 1]
                            .numberPhone.length >= 11
                    ) {
                        setMaskTelephone("(99) 99999-9999");
                    } else {
                        setMaskTelephone("(99) 9999-9999");
                    }

                    if (data.customerPhones[data.customerPhones.length - 1].numberPhone) setAlarmTelephone(false);
                    else setAlarmTelephone(true);
                    setTelephone(
                        data.customerPhones[data.customerPhones.length - 1]
                            .numberPhone
                    );

                    if (data.customerAddresses[data.customerAddresses.length - 1].zipCode) setAlarmCep(false);
                    else setAlarmCep(true);
                    setCep(
                        data.customerAddresses[
                            data.customerAddresses.length - 1
                        ].zipCode
                    );

                    if (data.customerAddresses[
                        data.customerAddresses.length - 1
                    ].zipCode) {
                        await findCep(data.customerAddresses[
                            data.customerAddresses.length - 1
                        ].zipCode)
                    }
                    if (data.customerAddresses[data.customerAddresses.length - 1].street) setAlarmAddress(false);
                    else setAlarmAddress(true);
                    setAddress(
                        data.customerAddresses[
                            data.customerAddresses.length - 1
                        ].street
                    );

                    if (data.customerAddresses[data.customerAddresses.length - 1].number) setAlarmNumber(false);
                    else setAlarmNumber(true);
                    setNumber(
                        data.customerAddresses[
                            data.customerAddresses.length - 1
                        ].number
                    );

                    setComplement(
                        data.customerAddresses[
                            data.customerAddresses.length - 1
                        ].extra
                    );

                    if (data.customerAddresses[data.customerAddresses.length - 1].district) setAlarmDistrict(false);
                    else setAlarmDistrict(true);
                    setDistrict(
                        data.customerAddresses[
                            data.customerAddresses.length - 1
                        ].district
                    );

                    if (data.customerAddresses[data.customerAddresses.length - 1].city) setAlarmCity(false);
                    else setAlarmCity(true);
                    setCity(
                        data.customerAddresses[
                            data.customerAddresses.length - 1
                        ].city
                    );

                    if (data.customerAddresses[data.customerAddresses.length - 1].state) setAlarmState(false);
                    else setAlarmState(true);
                    setState(
                        data.customerAddresses[
                            data.customerAddresses.length - 1
                        ].state
                    );
                } else {
                    clearCustomer();
                }
            })
            .catch((err) => {
                clearCustomer();
                setLoading(false);
                console.log(err);
            });
    }


    async function findCustomer2(documento: string) {

        setLoading(true);
        const cpfWithouthMask = cpfCnpjNoMask(documento);
        await api
            .post(
                `/api/customer/filter`,
                {
                    cpf: cpfWithouthMask,
                },
                {
                    headers: {
                        Authorization: `Bearer ${await getToken()}`,
                    },
                }
            )
            .then(async (response) => {
                setLoading(false);
                if (response.data.data.length > 0) {
                    const data = response.data.data[0];

                    const documento = data.doc.replace(/\D/g, "");

                    if (documento.length > 11) {
                        setSelectedDoc("cnpj");
                        setInscEstadual(data.inscEstadual);
                        setMaskCpfjCnpj('99.999.999/9999-99')
                    }

                    if (data.name) setAlarmName(false);
                    else setAlarmName(true)

                    setName(data.name)


                    if (data.email) setAlarmEmail(false);
                    else setAlarmEmail(true);
                    setEmail(data.email);

                    if (data.birthDate && data.birthDate != null) setAlarmBirthdate(false);
                    else setAlarmBirthdate(true);
                    setBirthdate(datetimeToDateBR(data.birthDate ? data.birthDate : ''));

                    if (data.gender) {
                        setGender(data.gender.toLowerCase());
                    } else {
                        setGender("masculino");
                    }

                    if (data.inscEstadual) {
                        setInscEstadual(data.inscEstadual);
                    }

                    if (
                        data.customerPhones[data.customerPhones.length - 1]
                            .numberPhone.length >= 11
                    ) {
                        setMaskTelephone("(99) 99999-9999");
                    } else {
                        setMaskTelephone("(99) 9999-9999");
                    }

                    if (data.customerPhones[data.customerPhones.length - 1].numberPhone) setAlarmTelephone(false);
                    else setAlarmTelephone(true);
                    setTelephone(
                        data.customerPhones[data.customerPhones.length - 1]
                            .numberPhone
                    );

                    if (data.customerAddresses[data.customerAddresses.length - 1].zipCode) setAlarmCep(false);
                    else setAlarmCep(true);
                    setCep(
                        data.customerAddresses[
                            data.customerAddresses.length - 1
                        ].zipCode
                    );

                    if (data.customerAddresses[
                        data.customerAddresses.length - 1
                    ].zipCode) {
                        await findCep(data.customerAddresses[
                            data.customerAddresses.length - 1
                        ].zipCode)
                    }
                    if (data.customerAddresses[data.customerAddresses.length - 1].street) setAlarmAddress(false);
                    else setAlarmAddress(true);
                    setAddress(
                        data.customerAddresses[
                            data.customerAddresses.length - 1
                        ].street
                    );

                    if (data.customerAddresses[data.customerAddresses.length - 1].number) setAlarmNumber(false);
                    else setAlarmNumber(true);
                    setNumber(
                        data.customerAddresses[
                            data.customerAddresses.length - 1
                        ].number
                    );

                    setComplement(
                        data.customerAddresses[
                            data.customerAddresses.length - 1
                        ].extra
                    );

                    if (data.customerAddresses[data.customerAddresses.length - 1].district) setAlarmDistrict(false);
                    else setAlarmDistrict(true);
                    setDistrict(
                        data.customerAddresses[
                            data.customerAddresses.length - 1
                        ].district
                    );

                    if (data.customerAddresses[data.customerAddresses.length - 1].city) setAlarmCity(false);
                    else setAlarmCity(true);
                    setCity(
                        data.customerAddresses[
                            data.customerAddresses.length - 1
                        ].city
                    );

                    if (data.customerAddresses[data.customerAddresses.length - 1].state) setAlarmState(false);
                    else setAlarmState(true);
                    setState(
                        data.customerAddresses[
                            data.customerAddresses.length - 1
                        ].state
                    );
                } else {
                    clearCustomer();
                }
            })
            .catch((err) => {
                clearCustomer();
                setLoading(false);
                console.log(err);
            });
    }

    function clearCustomer() {
        setName("");
        setEmail("");
        setBirthdate("");
        setGender("masculino");
        setTelephone("");
        /*
        setCep("");
        setAddress("");
        setNumber("");
        setComplement("");
        setDistrict("");
        setCity("");
        setState("");
        */
    }


    function createFieldDinamycally(data: configField) {
        switch (data.name) {
            case 'nome':
                return <>
                    {data.visible && (
                        <div className="input">
                            <label>{data.fieldName}</label>
                            <input
                                className={`${alarmName && 'alarm-input'}`}
                                type="text"
                                value={name}
                                onChange={(event) =>
                                    setName(event.target.value)
                                }
                                onFocus={() => setHideMenu(true)}
                                onBlur={() => {
                                    setHideMenu(false);
                                    ((name === undefined || name === "") && data.mandatory)
                                        ? setAlarmName(true)
                                        : setAlarmName(false);
                                }}
                            />
                            {alarmName && (
                                <p className="alarm-text">
                                    Informe um {data.fieldName}
                                </p>
                            )}
                        </div>
                    )

                    }
                </>
            case 'email':
                return <>
                    {data.visible && (

                        <div className="input">
                            <label>E-mail</label>
                            <input
                                className={`${alarmEmail && 'alarm-input'}`}
                                type="email"
                                value={email}
                                onChange={(event) =>
                                    setEmail(event.target.value)
                                }
                                onFocus={() => setHideMenu(true)}
                                onBlur={() => {
                                    setHideMenu(false);
                                    ((email === undefined || email === "" || !email.includes('@')) && data.mandatory)
                                        ? setAlarmEmail(true)
                                        : setAlarmEmail(false);
                                }}
                            />
                            {alarmEmail && (
                                <p className="alarm-text">
                                    Informe um e-mail válido
                                </p>
                            )}
                        </div>


                    )

                    }
                </>
            case 'dataNascimento':
                return <>
                    {data.visible && selectedDoc !== 'cnpj' && (
                        <div className="input">
                            <label>Data de Nascimento</label>
                            <InputMask
                                className={`${alarmBirthdate && 'alarm-input'}`}
                                mask={"99/99/9999"}
                                placeholder="XX/XX/XXXX"
                                type="text"
                                value={birthdate}
                                onChange={(event) =>
                                    setBirthdate(event.target.value)
                                }
                                onFocus={() => setHideMenu(true)}
                                onBlur={() => {
                                    setHideMenu(false);
                                    ((birthdate === undefined || birthdate === "" || birthdate[1] === "_") && data.mandatory)
                                        ? setAlarmBirthdate(true)
                                        : setAlarmBirthdate(false);
                                }}
                            />
                            {alarmBirthdate && (
                                <p className="alarm-text">
                                    Informe uma data de nascimento
                                </p>
                            )}
                        </div>
                    )

                    }
                </>
            case 'genero':
                return <>
                    {data.visible && selectedDoc !== 'cnpj' && (
                        <div className="input">
                            <label>Gênero</label>
                            <select
                                onChange={(e) => setGender(e.target.value)}
                                value={gender}
                            >
                                <option value="masculino">Masculino</option>
                                <option value="feminino">Feminino</option>
                                <option value="none">Não Informar</option>
                            </select>
                            {/*<div className='options'>
								<div className="option">
									<input type="radio" checked={gender === 'masculino'} onChange={() => setGender('masculino')} />
									<label>Masculino</label>
								</div>
								<div className="option">
									<input type="radio" checked={gender === 'feminino'} onChange={() => setGender('feminino')} />
									<label>Feminino</label>
								</div>
							</div> */
                            }
                        </div>
                    )

                    }
                </>
            case 'telefone':
                return <>
                    {data.visible && (
                        <div className="input">
                            <label>Telefone</label>
                            <InputMask
                                className={`${alarmTelephone && 'alarm-input'}`}
                                mask={maskTelephone}
                                placeholder="DDD + Telefone"
                                type="text"
                                value={telephone}
                                onBeforeInputCapture={(event) =>
                                    changeTelephone(
                                        event.currentTarget.value
                                    )
                                }
                                onChange={(event) =>
                                    setTelephone(event.target.value)
                                }
                                onFocus={() => setHideMenu(true)}
                                onBlur={() => {
                                    setHideMenu(false);
                                    (telephone[1] === "_" && data.mandatory)
                                        ? setAlarmTelephone(true)
                                        : setAlarmTelephone(false);
                                }}
                            />
                            {alarmTelephone && (
                                <p className="alarm-text">
                                    Informe o telefone
                                </p>
                            )}
                        </div>
                    )

                    }
                </>
        }
    }

    return (
        <div className="customer">
            <div className="content-customer">
                {!loadingHeader && (
                    <Header
                        background={
                            config?.webappcolor.backgroundheader
                                ? config?.webappcolor.backgroundheader
                                : "#F5F5F5"
                        }
                        colorIcon={
                            config?.webappcolor.iconsheader
                                ? config.webappcolor.iconsheader
                                : "#636363"
                        }
                        logo={config?.icon ? config.icon : ''}
                        backgroundCart={
                            config?.webappcolor.backgroundcart
                                ? config.webappcolor.backgroundcart
                                : "#FFBA49"
                        }
                        fontCart={
                            config?.webappcolor.fontcart
                                ? config.webappcolor.fontcart
                                : "#000"
                        }
                        noSales={
                            (config && config?.content && config?.content.pdv && config?.content.pdv.noSales)
                                ? config.content.pdv.noSales
                                : false
                        }
                    />
                )}
                {loading ?
                    <div style={{ width: '100%', height: 'calc(100vh)' }}>
                        <Loading type='spinningBubbles' color='#FFF' width={64} height={64} />
                    </div>
                    :
                    <div className="customer-body">
                        <h2>Cadastro</h2>
                        <div className="group-input">
                            {config?.content.pdv.allowSellCnpj && (
                                <div className="input">
                                    <div className="input-radio">
                                        <label className="label-row">
                                            <input
                                                type='radio'
                                                name='radio-doc'
                                                value={'cpf'}
                                                checked={selectedDoc === 'cpf'}
                                                onChange={(e) => {
                                                    setSelectedDoc(e.target.value)
                                                    setMaskCpfjCnpj("999.999.999-99");
                                                    setCpfOrCnpj('');
                                                }}
                                            />
                                            <span>CPF</span>
                                        </label>
                                        <label className="label-row" style={{ marginLeft: 12 }}>
                                            <input
                                                type='radio'
                                                name='radio-doc'
                                                value={'cnpj'}
                                                checked={selectedDoc === 'cnpj'}
                                                onChange={(e) => {
                                                    setSelectedDoc(e.target.value)
                                                    setMaskCpfjCnpj("99.999.999/9999-99");
                                                    setCpfOrCnpj('');
                                                }}
                                            />
                                            <span>CNPJ</span>
                                        </label>
                                    </div>
                                </div>
                            )}
                            <div className="input">
                                <label>{selectedDoc === 'cpf' ? 'CPF' : 'CNPJ'}</label>
                                <InputMask
                                    className={`${alarmCpf && 'alarm-input'}`}
                                    mask={maskCpfjCnpj}
                                    type="text"
                                    value={cpfOrCnpj}
                                    onChange={(event) =>
                                        setCpfOrCnpj(event.target.value)
                                    }
                                    onFocus={() => setHideMenu(true)}
                                    onBlur={() => {
                                        setHideMenu(false);
                                        findCustomer();
                                        orderContext.changeCustomerDocument(cpfOrCnpj)

                                    }}
                                />
                                {alarmCpf && (
                                    <p className="alarm-text">Informe um {selectedDoc === 'cpf' ? 'CPF' : 'CNPJ'} válido</p>
                                )}
                            </div>
                            {selectedDoc === 'cnpj' && (
                                <div className="input">
                                    <label>Inscrição Estadual</label>
                                    <input
                                        type="text"
                                        value={inscEstadual}
                                        onChange={(event) =>
                                            setInscEstadual(event.target.value)
                                        }
                                        onFocus={() => setHideMenu(true)}
                                        onBlur={() => {
                                            setHideMenu(false);
                                        }}
                                    />
                                </div>
                            )}

                            {/* Configurar se tem ou não as configurações de Field */}
                            <>
                                {(!haveFieldConfig) ? (
                                    <>
                                        <div className="input">
                                            <label>Nome do Comprador</label>
                                            <input
                                                className={`${alarmName && 'alarm-input'}`}
                                                type="text"
                                                value={name}
                                                onChange={(event) =>
                                                    setName(event.target.value)
                                                }
                                                onFocus={() => setHideMenu(true)}
                                                onBlur={() => {
                                                    setHideMenu(false);
                                                    name === undefined || name === ""
                                                        ? setAlarmName(true)
                                                        : setAlarmName(false);
                                                }}
                                            />
                                            {alarmName && (
                                                <p className="alarm-text">
                                                    Informe um nome
                                                </p>
                                            )}
                                        </div>
                                        <div className="input">
                                            <label>E-mail</label>
                                            <input
                                                className={`${alarmEmail && 'alarm-input'}`}
                                                type="email"
                                                value={email}
                                                onChange={(event) =>
                                                    setEmail(event.target.value)
                                                }
                                                onFocus={() => setHideMenu(true)}
                                                onBlur={() => {
                                                    setHideMenu(false);
                                                    email === undefined ||
                                                        email === "" ||
                                                        !email.includes('@')
                                                        ? setAlarmEmail(true)
                                                        : setAlarmEmail(false);
                                                }}
                                            />
                                            {alarmEmail && (
                                                <p className="alarm-text">
                                                    Informe um e-mail válido
                                                </p>
                                            )}
                                        </div>
                                        {selectedDoc !== 'cnpj' && (
                                            <>
                                                <div className="input">
                                                    <label>Data de Nascimento</label>
                                                    <InputMask
                                                        className={`${alarmBirthdate && 'alarm-input'}`}
                                                        mask={"99/99/9999"}
                                                        placeholder="XX/XX/XXXX"
                                                        type="text"
                                                        value={birthdate}
                                                        onChange={(event) =>
                                                            setBirthdate(event.target.value)
                                                        }
                                                        onFocus={() => setHideMenu(true)}
                                                        onBlur={() => {
                                                            setHideMenu(false);
                                                            birthdate === undefined ||
                                                                birthdate === "" ||
                                                                birthdate[1] === "_"
                                                                ? setAlarmBirthdate(true)
                                                                : setAlarmBirthdate(false);
                                                        }}
                                                    />
                                                    {alarmBirthdate && (
                                                        <p className="alarm-text">
                                                            Informe uma data de nascimento
                                                        </p>
                                                    )}
                                                </div>
                                                <div className="input">
                                                    <label>Gênero</label>
                                                    <select
                                                        onChange={(e) => setGender(e.target.value)}
                                                        value={gender}
                                                    >
                                                        <option value="masculino">Masculino</option>
                                                        <option value="feminino">Feminino</option>
                                                        <option value="none">Não Informar</option>
                                                    </select>
                                                    {/* <div className='options'>
                                                <div className="option">
                                                    <input type="radio" checked={gender === 'masculino'} onChange={() => setGender('masculino')}  />
                                                    <label>Masculino</label>
                                                </div>
                                                <div className="option">
                                                    <input type="radio" checked={gender === 'feminino'} onChange={() => setGender('feminino')} />
                                                    <label>Feminino</label>
                                                </div>
                                                </div> */
                                                    }
                                                </div>
                                            </>
                                        )}
                                        <div className="input">
                                            <label>Telefone</label>
                                            <InputMask
                                                className={`${alarmTelephone && 'alarm-input'}`}
                                                mask={maskTelephone}
                                                placeholder="DDD + Telefone"
                                                type="text"
                                                value={telephone}
                                                onBeforeInputCapture={(event) =>
                                                    changeTelephone(
                                                        event.currentTarget.value
                                                    )
                                                }
                                                onChange={(event) =>
                                                    setTelephone(event.target.value)
                                                }
                                                onFocus={() => setHideMenu(true)}
                                                onBlur={() => {
                                                    setHideMenu(false);
                                                    telephone[1] === "_"
                                                        ? setAlarmTelephone(true)
                                                        : setAlarmTelephone(false);
                                                }}
                                            />
                                            {alarmTelephone && (
                                                <p className="alarm-text">
                                                    Informe o telefone
                                                </p>
                                            )}
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="input">
                                            <label>Nome do Comprador</label>
                                            <input
                                                className={`${alarmName && 'alarm-input'}`}
                                                type="text"
                                                value={name}
                                                onChange={(event) =>
                                                    setName(event.target.value)
                                                }
                                                onFocus={() => setHideMenu(true)}
                                                onBlur={() => {
                                                    setHideMenu(false);
                                                    name === undefined || name === ""
                                                        ? setAlarmName(true)
                                                        : setAlarmName(false);
                                                }}
                                            />
                                            {alarmName && (
                                                <p className="alarm-text">
                                                    Informe um nome
                                                </p>
                                            )}
                                        </div>
                                        {fieldsConfig.map((fieldConfig: configField) => (
                                            createFieldDinamycally(fieldConfig)
                                        )
                                        )

                                        }

                                    </>
                                )

                                }

                            </>
                            <>
                                {
                                    // Se tipo Food e retirada(withdraw) n é para mostrar os campos de entr
                                    (typePluginSpace !== 'food') && (
                                        <>

                                            <div className="input">
                                                <label>CEP</label>
                                                <InputMask
                                                    className={`${alarmCep && 'alarm-input'}`}
                                                    mask="99999-999"
                                                    type="text"
                                                    value={cep}
                                                    onChange={(event) =>
                                                        setCep(event.target.value)
                                                    }
                                                    onFocus={() => setHideMenu(true)}
                                                    onBlur={(event) => {
                                                        setHideMenu(false);
                                                        if (cep[0] === "_") {
                                                            setAlarmCep(true);
                                                        } else {
                                                            findCep(event.target.value);
                                                            setAlarmCep(false);
                                                        }
                                                    }}
                                                />
                                                {alarmCep && (
                                                    <p className="alarm-text">Informe o CEP</p>
                                                )}
                                            </div>
                                            <div className="input">
                                                <label>Endereço</label>
                                                <input
                                                    className={`${alarmAddress && 'alarm-input'}`}
                                                    type="text"
                                                    value={address}
                                                    onChange={(event) =>
                                                        setAddress(event.target.value)
                                                    }
                                                    onFocus={() => setHideMenu(true)}
                                                    onBlur={() => {
                                                        setHideMenu(false);
                                                        address === undefined || address === ""
                                                            ? setAlarmAddress(true)
                                                            : setAlarmAddress(false);
                                                    }}
                                                />
                                                {alarmAddress && (
                                                    <p className="alarm-text">
                                                        Informe um endereço
                                                    </p>
                                                )}
                                            </div>
                                            <div className="input">
                                                <label>Número</label>
                                                <input
                                                    className={`${alarmNumber && 'alarm-input'}`}
                                                    type="text"
                                                    value={number}
                                                    onChange={(event) =>
                                                        setNumber(
                                                            event.target.value
                                                                .replace(/[^0-9.]/g, "")
                                                                .replace(/(\..*?)\..*/g, "$1")
                                                        )
                                                    }
                                                    onFocus={() => setHideMenu(true)}
                                                    onBlur={() => {
                                                        setHideMenu(false);
                                                        number === undefined || number === ""
                                                            ? setAlarmNumber(true)
                                                            : setAlarmNumber(false);
                                                    }}
                                                />
                                                {alarmNumber && (
                                                    <p className="alarm-text">
                                                        Informe o número do endereço
                                                    </p>
                                                )}
                                            </div>
                                            <div className="input">
                                                <label>Nome deste endereço</label>
                                                <input
                                                    type="text"
                                                    value={complement}
                                                    onChange={(event) =>
                                                        setComplement(event.target.value)
                                                    }
                                                    placeholder="(Exemplo: casa, trabalho, etc)"
                                                    onFocus={() => setHideMenu(true)}
                                                    onBlur={() => {
                                                        setHideMenu(false);
                                                        !complement
                                                            ? setAlarmComplement(true)
                                                            : setAlarmComplement(false);
                                                    }}
                                                />
                                                {alarmComplement && (
                                                    <p className="alarm-text">
                                                        Informe o nome do endereço
                                                    </p>
                                                )}
                                            </div>
                                            <div className="input">
                                                <label>Bairro</label>
                                                <input
                                                    className={`${alarmDistrict && 'alarm-input'}`}
                                                    type="text"
                                                    value={district}
                                                    onChange={(event) =>
                                                        setDistrict(event.target.value)
                                                    }
                                                    onFocus={() => setHideMenu(true)}
                                                    onBlur={() => {
                                                        setHideMenu(false);
                                                        district === undefined ||
                                                            district === ""
                                                            ? setAlarmDistrict(true)
                                                            : setAlarmDistrict(false);
                                                    }}
                                                />
                                                {alarmDistrict && (
                                                    <p className="alarm-text">
                                                        Informe um bairro
                                                    </p>
                                                )}
                                            </div>
                                            <div className="inputs">
                                                <div className="input">
                                                    <label>Cidade</label>
                                                    <input
                                                        className={`${alarmCity && 'alarm-input'}`}
                                                        type="text"
                                                        value={city}
                                                        onChange={(event) =>
                                                            setCity(event.target.value)
                                                        }
                                                        onFocus={() => setHideMenu(true)}
                                                        onBlur={() => {
                                                            setHideMenu(false);
                                                            city === undefined || city === ""
                                                                ? setAlarmCity(true)
                                                                : setAlarmCity(false);
                                                        }}
                                                    />
                                                    {alarmCity && (
                                                        <p className="alarm-text">
                                                            Informe uma cidade
                                                        </p>
                                                    )}
                                                </div>
                                                <div className="input" style={{ width: "20%" }}>
                                                    <label>Estado</label>
                                                    <input
                                                        className={`${alarmState && 'alarm-input'}`}
                                                        type="text"
                                                        value={state}
                                                        onChange={(event) =>
                                                            setState(event.target.value)
                                                        }
                                                        onFocus={() => setHideMenu(true)}
                                                        onBlur={() => {
                                                            setHideMenu(false);
                                                            state === undefined || state === ""
                                                                ? setAlarmState(true)
                                                                : setAlarmState(false);
                                                        }}
                                                    />
                                                    {alarmState && (
                                                        <p className="alarm-text">
                                                            Informe um estado
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        </>
                                    )
                                }


                            </>

                        </div>
                        <div className="button-continue">
                            <MainButton
                                color={
                                    config?.webappcolor.fontbutton
                                        ? config.webappcolor.fontbutton
                                        : "#636363"
                                }
                                backgroundColor={
                                    config?.webappcolor.webappbutton
                                        ? config.webappcolor.webappbutton
                                        : "#EAEAEA"
                                }
                                text="Gerar Link de Pagamento"
                                onClick={continueOrder}
                            />
                        </div>
                    </div>
                }
                {!loadingHeader && (
                    <Menu
                        activeMenu="cart"
                        fontColor={
                            config?.webappcolor.iconsfooter
                                ? config?.webappcolor.iconsfooter
                                : "#636363"
                        }
                        activeFontColor={
                            config?.webappcolor.highlightfooter
                                ? config?.webappcolor.highlightfooter
                                : "#000"
                        }
                        backgroundMenu={
                            config?.webappcolor.backgroundfooter
                                ? config?.webappcolor.backgroundfooter
                                : "#F5F5F5"
                        }
                        colorIcons={
                            config?.webappcolor.iconsfooter
                                ? config?.webappcolor.iconsfooter
                                : "#636363"
                        }
                        highlightColorIcons={
                            config?.webappcolor.highlightfooter
                                ? config?.webappcolor.highlightfooter
                                : "#636363"
                        }
                        hide={hideMenu}
                        backgroundCart={config?.webappcolor.backgroundcart ? config.webappcolor.backgroundcart : '#FFBA49'}
                        fontCart={config?.webappcolor.fontcart ? config.webappcolor.fontcart : '#000'}
                        noSales={
                            (config && config?.content && config?.content.pdv && config?.content.pdv.noSales)
                                ? config.content.pdv.noSales
                                : false
                        }
                    />
                )}
            </div>
        </div>
    );
}